// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Zc+Xk","ftr1":"Footer_ftr1__ijRGu","acc":"Footer_acc__pdfSI","quick":"Footer_quick__1z8CA","icon":"Footer_icon__X7LtC","ftr2":"Footer_ftr2__yR8pY"};